import styled from "styled-components";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import {useState, useEffect} from 'react'
import data from "./data/data.json"

import {ThemeProvider} from "./contexts/ThemeContext";

import './styles/GlobalStyles'
import GlobalStyles from "./styles/GlobalStyles";
import Container from "./components/Container";
import Page404 from "./components/404Page"

function App() {
    const [initialData, setInitidalData] = useState([]);


    useEffect(() => {
        setInitidalData(data);
    }, []);


  return (
      <ThemeProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={
                        <Wrapper>
                            <GlobalStyles/>
                            <Container items={initialData}/>
                        </Wrapper>
                    }>
                    </Route>
                    <Route path="*" element={<Page404 />} />
                </Routes>
            </BrowserRouter>
      </ThemeProvider>
  );
}

const Wrapper  = styled.main`
  display: flex;
  flex-direction: column;
  gap: 30px;
`
export default App;
